commusoftCommon.filter('userReminderDateFormat', function() {
    return function(dateString) {
        if (dateString == '' || dateString == undefined) {
            return '';
        }
        return moment(dateString).format('ddd Do MMMM YYYY')
    };
});